import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const DugunReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [eventInfo, setEventInfo] = useState({ eventName: '', clientName: '', eventDate: new Date().toISOString().split('T')[0], location: '' });
  const [services, setServices] = useState([{ serviceName: '', price: 0, deposit: 0, remaining: 0 }]);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    const totalPrice = services.reduce((sum, item) => sum + item.price, 0);
    const totalDeposit = services.reduce((sum, item) => sum + item.deposit, 0);
    const totalRemaining = totalPrice - totalDeposit;
    onDataChange({ ...eventInfo, services, notes, totalPrice, totalDeposit, totalRemaining, date: new Date().toLocaleDateString() });
  }, [eventInfo, services, notes, onDataChange]);

  const handleServiceChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    if (field === 'price' || field === 'deposit') {
      newServices[index].remaining = newServices[index].price - newServices[index].deposit;
    }
    setServices(newServices);
  };

  const totalPrice = services.reduce((sum, item) => sum + item.price, 0);
  const totalDeposit = services.reduce((sum, item) => sum + item.deposit, 0);
  const totalRemaining = totalPrice - totalDeposit;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField label="Event Name" name="eventName" value={eventInfo.eventName} onChange={(e) => setEventInfo({ ...eventInfo, eventName: e.target.value })} placeholder="Wedding ceremony" required />
        <InputField label="Client Name" name="clientName" value={eventInfo.clientName} onChange={(e) => setEventInfo({ ...eventInfo, clientName: e.target.value })} placeholder="Client name" />
        <InputField label="Event Date" name="eventDate" type="date" value={eventInfo.eventDate} onChange={(e) => setEventInfo({ ...eventInfo, eventDate: e.target.value })} />
        <InputField label="Location" name="location" value={eventInfo.location} onChange={(e) => setEventInfo({ ...eventInfo, location: e.target.value })} placeholder="Venue" />
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Services</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Service</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Price</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Deposit</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Remaining</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {services.map((service, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={service.serviceName} onChange={(e) => handleServiceChange(index, 'serviceName', e.target.value)} placeholder="e.g., Catering, Decoration" /></td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={service.price} onChange={(e) => handleServiceChange(index, 'price', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={service.deposit} onChange={(e) => handleServiceChange(index, 'deposit', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2 text-right font-medium text-[#111418] dark:text-gray-100">${service.remaining.toFixed(2)}</td>
                  <td className="p-2 text-center"><button onClick={() => setServices(services.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={services.length === 1}><span className="material-symbols-outlined text-xl">delete</span></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setServices([...services, { serviceName: '', price: 0, deposit: 0, remaining: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Service</Button>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3 bg-gray-50 dark:bg-gray-900 p-4 rounded-lg">
          <div className="flex justify-between items-center"><span className="text-gray-600 dark:text-gray-400">Total Price</span><span className="font-medium text-[#111418] dark:text-gray-100">${totalPrice.toFixed(2)}</span></div>
          <div className="flex justify-between items-center"><span className="text-gray-600 dark:text-gray-400">Total Deposit</span><span className="font-medium text-green-600 dark:text-green-400">${totalDeposit.toFixed(2)}</span></div>
          <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700"><span className="text-lg font-bold text-[#111418] dark:text-gray-100">Remaining Balance</span><span className="text-lg font-bold text-primary">${totalRemaining.toFixed(2)}</span></div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Event requirements, special requests..." rows={3} />
    </div>
  );
};

export default DugunReportForm;
